import { dailyScheduleFactory } from "./daily-schedule";
import { dailyScheduleTimeRangeFactory } from "./daily-schedule-time-range";

const generateFullDayDailySchedule = () =>
    dailyScheduleFactory({
        timeRange: dailyScheduleTimeRangeFactory(
            {
                hour: 0,
                minute: 0,
            },
            {
                hour: 23,
                minute: 59,
            },
        )[0],
    });

export { generateFullDayDailySchedule };
